/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsPhotoCarousel_photos = ReadonlyArray<{
    readonly id: string;
    readonly serviceId: string | null;
    readonly path: string | null;
    readonly name: string | null;
    readonly " $fragmentRefs": FragmentRefs<"usePhotosLikeDataRefetch_photos" | "SbSharedInteriorsHeartWrapper_photo">;
    readonly " $refType": "SbRespInteriorsPhotoCarousel_photos";
}>;
export type SbRespInteriorsPhotoCarousel_photos$data = SbRespInteriorsPhotoCarousel_photos;
export type SbRespInteriorsPhotoCarousel_photos$key = ReadonlyArray<{
    readonly " $data"?: SbRespInteriorsPhotoCarousel_photos$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsPhotoCarousel_photos">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbRespInteriorsPhotoCarousel_photos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePhotosLikeDataRefetch_photos"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedInteriorsHeartWrapper_photo"
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};
(node as any).hash = '0898ed565145489f6e73aa06d2775ce7';
export default node;
